 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLDEDICATION from '@/components/xhtml/Dedication'
 import XHTMLCONTENTS from '@/components/xhtml/Contents'
 import XHTMLACKNOWLEDGMENTS from '@/components/xhtml/Acknowledgments'
 import XHTMLNOTES_ON_THE_TEXT from '@/components/xhtml/Notes_on_the_Text'
 import XHTMLPROLOGUE from '@/components/xhtml/Prologue'
 import XHTMLAMSTERDAM from '@/components/xhtml/Amsterdam'
 import XHTMLCHAPTER001 from '@/components/xhtml/Chapter001'
 import XHTMLCHAPTER002 from '@/components/xhtml/Chapter002'
 import XHTMLCHAPTER003 from '@/components/xhtml/Chapter003'
 import XHTMLCHAPTER004 from '@/components/xhtml/Chapter004'
 import XHTMLCHAPTER005 from '@/components/xhtml/Chapter005'
 import XHTMLPHOTOS from '@/components/xhtml/Photos'
 import XHTMLCHAPTER006 from '@/components/xhtml/Chapter006'
 import XHTMLCHAPTER007 from '@/components/xhtml/Chapter007'
 import XHTMLCHAPTER008 from '@/components/xhtml/Chapter008'
 import XHTMLCHAPTER009 from '@/components/xhtml/Chapter009'
 import XHTMLCHAPTER010 from '@/components/xhtml/Chapter010'
 import XHTMLEPILOGUE from '@/components/xhtml/Epilogue'
 import XHTMLNOTES from '@/components/xhtml/Notes'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Contents",
 			"name" : "xhtml/Contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/Acknowledgments",
 			"name" : "xhtml/Acknowledgments",
 			"component" : XHTMLACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/Notes_on_the_Text",
 			"name" : "xhtml/Notes_on_the_Text",
 			"component" : XHTMLNOTES_ON_THE_TEXT
 		},
 		{
 			"path" : "/xhtml/Prologue",
 			"name" : "xhtml/Prologue",
 			"component" : XHTMLPROLOGUE
 		},
 		{
 			"path" : "/xhtml/Amsterdam",
 			"name" : "xhtml/Amsterdam",
 			"component" : XHTMLAMSTERDAM
 		},
 		{
 			"path" : "/xhtml/Chapter001",
 			"name" : "xhtml/Chapter001",
 			"component" : XHTMLCHAPTER001
 		},
 		{
 			"path" : "/xhtml/Chapter002",
 			"name" : "xhtml/Chapter002",
 			"component" : XHTMLCHAPTER002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js